import { NgModule } from "@angular/core";
import { UiBadgeComponent } from "./badge.component";
import { UiRibbonComponent } from "./components/ribbon/ribbon.component";

@NgModule({
  imports: [UiBadgeComponent, UiRibbonComponent],
  exports: [UiBadgeComponent, UiRibbonComponent],
})
export class UiBadgeModule {}
